var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "#5B78FF",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.33307 13.3627L6.69248 14.7328L13.9078 7.4606L12.5484 6.09048L5.33307 13.3627ZM11.921 5.45812L10.5616 4.088L3.34624 11.3602L4.81022 12.8357L11.921 5.45812ZM14.117 0.5046L17.5678 3.9826C18.1952 4.61496 18.0906 5.56351 17.5678 6.09048L7.21533 16.5245L0 18L1.46398 10.7278C7.94732 4.088 11.3981 0.609994 11.8164 0.293812C12.4438 -0.127763 13.4895 -0.127763 14.117 0.5046Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/Pencil.2e52d3f4.svg";
export { ForwardRef as ReactComponent };